/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'
import { EffectCards, Mousewheel } from 'swiper/modules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars,
  faVolumeXmark,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'
import { Button, Image } from 'react-bootstrap'
import { mobilePhone, wavenet_logo, dragging } from '../asset'
import CIIcon from './CIIcon'

function SlidingCoverMultiStickyPreview({
  srcs,
  redirectImage,
  redirectVideo,
}) {
  const [showIntro, setShowIntro] = useState(false)
  const [imageUrls, setImageUrls] = useState([])
  const [hasPlayedIntro, setHasPlayedIntro] = useState(false)
  const bottomVideoRef = useRef(null)
  const [showSwiper, setShowSwiper] = useState(true)
  const [isMuted, setIsMuted] = useState(true)

  const swiperRef = useRef(null)
  const containerRef = useRef(null)

  const IntroVideo = srcs.find((s) => s.label === 'Intro video')
  const BottomVideo = srcs.find((s) => s.label === 'Bottom video')

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'string') {
      return file
    }
    return ''
  }

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const handleScroll = () => {
      if (hasPlayedIntro || !bottomVideoRef.current) return

      const rect = bottomVideoRef.current.getBoundingClientRect()
      const containerRect = container.getBoundingClientRect()

      const fullyInView =
        rect.top >= containerRect.top && rect.bottom <= containerRect.bottom

      if (fullyInView) {
        setShowIntro(true)
        setHasPlayedIntro(true)
      }
    }

    container.addEventListener('scroll', handleScroll)

    return () => {
      container.removeEventListener('scroll', handleScroll)
    }
  }, [hasPlayedIntro])

  useEffect(() => {
    const urlsToRevoke = []

    const Pic = srcs
      .filter((s) => s.label?.startsWith('Pic'))
      .sort((a, b) => {
        const getNum = (label) => parseInt(label.match(/\d+$/)?.[0] || '0', 10)
        return getNum(a.label) - getNum(b.label)
      })

    const urls = Pic.map((img) => {
      if (img?.file instanceof File || img?.file instanceof Blob) {
        const url = URL.createObjectURL(img.file)
        urlsToRevoke.push(url)
        return url
      }
      if (typeof img?.file === 'string') return img.file
      return ''
    })

    setImageUrls(urls)

    return () => {
      // urlsToRevoke.forEach((url) => URL.revokeObjectURL(url))
    }
  }, [srcs])

  useEffect(() => {
    if (showIntro && IntroVideo?.file) {
      const timer = setTimeout(() => {
        setShowIntro(false)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [showIntro])

  return (
    <div
      ref={containerRef}
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      {/* 頂部內容 */}
      <div className="w-100 pb-1">
        <img
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
          alt="Mobile Phone"
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      {IntroVideo?.file && showIntro && (
        <video
          src={getPreviewURL(IntroVideo.file)}
          autoPlay
          muted
          playsInline
          style={{
            position: 'absolute',
            top: '30%',
            width: '240px',
            zIndex: 2000,
          }}
        />
      )}

      {!showIntro && showSwiper && imageUrls.length > 0 && (
        <div style={{ position: 'relative', width: '230px' }}>
          <Button
            onClick={() => setShowSwiper(false)}
            style={{
              position: 'absolute',
              top: '3%',
              right: '0%',
              zIndex: 2100,
              background: 'rgba(0,0,0,0.5)',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: '23px',
              height: '23px',
              fontSize: '12px',
              padding: '0',
              cursor: 'pointer',
            }}
          >
            ✕
          </Button>
          <img
            src={dragging}
            alt="Drag Hint"
            style={{
              position: 'absolute',
              bottom: '65%',
              left: '15px',
              width: '40px',
              height: 'auto',
              zIndex: 1150,
              animation: 'dragHintLeftRight 1.8s ease-in-out infinite',
              pointerEvents: 'none',
              opacity: 0.75,
              backgroundColor: 'rgba(255,255,255,0.8)',
              borderRadius: '50%',
              cursor: 'grab',
            }}
          />
          <Swiper
            ref={swiperRef}
            spaceBetween={50}
            slidesPerView={1}
            effect="cards"
            modules={[EffectCards, Mousewheel]}
            mousewheel
            className="p-3"
            style={{ width: '240px', height: 'auto' }}
            onClick={() => {
              if (redirectImage) window.open(redirectImage, '_blank')
            }}
          >
            {imageUrls.map((src, index) => (
              <SwiperSlide key={index} className="slide-card-img">
                <img src={src} alt={`Pic ${index + 1}`} />
              </SwiperSlide>
            ))}
            <CIIcon />
          </Swiper>
        </div>
      )}

      {BottomVideo?.file && showSwiper && (
        <div
          style={{ position: 'relative', width: '240px', marginTop: '12px' }}
        >
          <video
            ref={bottomVideoRef}
            src={getPreviewURL(BottomVideo.file)}
            autoPlay
            loop
            muted={isMuted}
            playsInline
            onClick={() => {
              if (redirectVideo) window.open(redirectVideo, '_blank')
            }}
            style={{
              width: '240px',
              height: 'auto',
              marginTop: '12px',
              cursor: 'pointer',
            }}
          />
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation() // 避免點擊按鈕觸發影片外連
              e.preventDefault()
              setIsMuted((prev) => !prev)
            }}
            style={{
              position: 'absolute',
              left: '5px',
              bottom: '10px',
              zIndex: 1100,
              backgroundColor: 'rgba(0,0,0,0.5)',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              color: 'white',
              fontSize: '16px',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            aria-label={isMuted ? 'Unmute video' : 'Mute video'}
          >
            <FontAwesomeIcon icon={isMuted ? faVolumeXmark : faVolumeHigh} />
          </button>
        </div>
      )}

      {/* 底部內容 */}
      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

SlidingCoverMultiStickyPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
    })
  ).isRequired,
  redirectImage: PropTypes.string,
  redirectVideo: PropTypes.string,
}

SlidingCoverMultiStickyPreview.defaultProps = {
  redirectImage: '',
  redirectVideo: '',
}

export default SlidingCoverMultiStickyPreview
